// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fmFY","title":"styles_title__Rzovi"};